<!-- Vertical segmented toggle on the left edge for History / Analytics drawers. -->
<template>
  <div class="side-tabs is-hidden-touch">
    <button
      class="side-tab"
      :class="{ 'is-active': analyticsOpen }"
      @click="toggleAnalytics"
    >
      <span class="icon is-small">
        <FontAwesomeIcon :icon="faChartBar" />
      </span>
      <span>Analytics</span>
    </button>
    <button
      class="side-tab"
      :class="{ 'is-active': historyOpen }"
      @click="toggleHistory"
    >
      <span class="icon is-small">
        <FontAwesomeIcon :icon="faHistory" />
      </span>
      <span>History</span>
    </button>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHistory, faChartBar } from '@fortawesome/free-solid-svg-icons'

const props = defineProps({
  historyOpen: Boolean,
  analyticsOpen: Boolean,
})

const emit = defineEmits(['update:historyOpen', 'update:analyticsOpen'])

function toggleHistory() {
  if (props.historyOpen && !props.analyticsOpen) {
    emit('update:historyOpen', false)
  } else {
    emit('update:historyOpen', true)
    emit('update:analyticsOpen', false)
  }
}

function toggleAnalytics() {
  if (props.analyticsOpen) {
    emit('update:historyOpen', false)
    emit('update:analyticsOpen', false)
  } else {
    emit('update:historyOpen', true)
    emit('update:analyticsOpen', true)
  }
}
</script>

<style scoped>
.side-tabs {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  transform-origin: left top;
  z-index: 30;
  display: flex;
  flex-direction: row;
}

.side-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: calc(0.5em - 1px) 1em;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  background: var(--bulma-scheme-main);
  color: var(--bulma-text);
  border: 1px solid var(--bulma-border);
  border-top: none;
  border-radius: 0;
  transition: background 0.15s, color 0.15s;
}

.side-tab:first-child {
  border-bottom-left-radius: var(--bulma-radius);
}
.side-tab:last-child {
  border-bottom-right-radius: var(--bulma-radius);
  border-left: none;
}

.side-tab:hover:not(.is-active) {
  background: var(--bulma-scheme-main-bis);
}

.side-tab.is-active {
  background: var(--bulma-scheme-main-bis);
  color: var(--bulma-text-strong);
  font-weight: 500;
  border-color: var(--bulma-border);
}
</style>
